export default __webpack_public_path__ + "static/media/2responsive.e921139c.jpeg";